import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import HomeIcon from "@mui/icons-material/Home";
import DescriptionIcon from "@mui/icons-material/Description";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import PlaylistPlayIcon from "@mui/icons-material/PlaylistPlay";

import CustomForm from "../../../helper-components/form/CustomForm";
import NavigationFooter from "../../../helper-components/misc/NavigationFooter";

import PlaylistsTable from "./components/PlaylistsTable";

import { getLanguage } from "../../../config/language/language.js";

/**
 * The playlists page.
 */
export default function Playlists(props) {
    return (
        <Container maxWidth="xl" sx={{ mt: 2, mb: 2 }}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <CustomForm title={getLanguage().PLAYLISTS_TITLE} subtitle={getLanguage().PLAYLISTS_SUBTITLE} icon={<PlaylistPlayIcon />} />
                </Grid>

                <Grid item xs={12}>
                    <PlaylistsTable {...props} />
                </Grid>

                <NavigationFooter
                    rows={2}
                    options={[
                        {
                            path: `/database/libraries`,
                            title: "Libraries",
                            variant: "outlined",
                            icon: <SubscriptionsIcon />
                        },
                        {
                            path: `/database/resources`,
                            title: "Resources",
                            variant: "outlined",
                            icon: <DescriptionIcon />
                        },
                        {
                            path: `/home`,
                            title: "Home",
                            variant: "outlined",
                            icon: <HomeIcon />
                        }
                    ]}
                />
            </Grid>
        </Container>
    );
}
